import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from './Button';

export default class SecondaryButton extends Component<any, any> {
    [key: string]: any;
    static [key: string]: any;
    static propTypes = {
        onClick: PropTypes.func,
        text: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        onClick: () => {},
        disabled: false,
    };

    render() {
        return (
            <Button
                onClick={this.props.onClick}
                text={this.props.text}
                type="secondary"
                disabled={this.props.disabled}
            />
        );
    }
}
